import { Output, EventEmitter, Component, ChangeDetectionStrategy } from '@angular/core';

import { CardModel } from '@modules/card/models/card.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export abstract class SectionDefaultsComponent {
  @Output() openMedia = new EventEmitter();

  openCardMedia(data: CardModel) {
    if (!data.link && data.media) {
      this.openMedia.emit(data.media);
    }
  }
}
